(function () {
    'use strict';

    angular
        .module('app')
        .directive('froala', froala);

    froala.$inject = ['$window', '$timeout', 'dataCardService'];

    function froala($window, $timeout, dataCardService) {
        // Usage:
        //     <froala></froala>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                ngModel: "=?",
                changed: "=?",
                disabled: "=?",
                editor: "=",
            }
        };
        return directive;

        function link(scope, element, attrs) {
            scope.froalaEditor = scope.froalaEditor || {};

            $timeout(function () {
                var toolbarButtons = ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript',
        'fontFamily', 'fontSize', 'color',
        'formatBlock', 'blockStyle', 'inlineStyle', 'align',
        'formatOL', 'formatUL', 'outdent', 'indent', 'selectAll',
        'createLink',
        'insertImage',
        'insertVideo',
        'table', 'undo', 'redo', 'html',
        'insertHorizontalRule',
        'uploadFile',
        'removeFormat', 'fullscreen'];


                var containerHeight = $('.memo-tab').height() - 42;

                $timeout(function () {
                    $('.fr-view').on('input propertychange', function () {
                        $timeout(function () {
                            scope.$apply(function () {
                                var currentValue = scope.ngModel;
                                if (originalValue != currentValue) {
                                    if (scope.changed) {
                                        //call the listener
                                        scope.changed();
                                    }
                                }
                            });
                        });
                    })
                })

                // Version 3.x & 4.x lSA3D-17E4E2A2C1F1H2rXYb1VPUGRHYZNRJd1JVOOb1HAc1zG2B1A2A2D6B1C1C4G1A3==
                // Versions >= 2.8.0 lB2B3B1B2D2A2wG1G1B2D2B1D7A5E1D4G4jXa1TEWUf1d1QSDb1HAc1==
                // Versions < 2.8.0 lJCJWECHICc2JOZWJ==

                //initialize the editor
                var froalaEditor = $(element).froalaEditor({
                    key: 'lJCJWECHICc2JOZWJ==',
                    inlineMode: false,
                    height: containerHeight,
                    placeholderText: "",
                    imageUploadURL: "../Synergis.WebApi/api/Image/Upload",
                    imageUploadParam: 'image_param',
                    imagePase: true,
                    toolbarButtons: toolbarButtons,
                    toolbarButtonsMD: toolbarButtons,
                    toolbarButtonsSM: toolbarButtons,
                    toolbarButtonsXS: toolbarButtons
                });

                //to keep track of a local update
                var localUpdate = false;

                $(window).resize(function () {
                    resize();
                })

                function resize() {
                    var toolbarSize = parseInt($(".fr-toolbar").css('height'));
                    console.log("toobarsize", toolbarSize);
                    var containerHeight = $('.memo-tab').height() - (toolbarSize);
                    $('.fr-wrapper').css('height', containerHeight);
                    $('.fr-element').css('height', containerHeight);
                    console.log
                }

                $timeout(function () {
                    resize();
                });


                $(element).on('froalaEditor.contentChanged', function (e, editor) {
                    //if it's a local update, set this flag to true so the watch knows not to set the editor's content
                    localUpdate = true;
                    //since this is coming outside of angular we must call $apply to properly update the model.
                    scope.$apply(function () {
                        //set the model to the content of the editor
                        scope.ngModel = editor.html.get();
                        var currentValue = scope.ngModel;

                        if (originalValue != currentValue) {
                            var difference = getDifference(originalValue, currentValue);
                            //ensure that the difference between the current value and the original is not just a draggable tag.
                            difference = difference.trim();
                            var differences = difference.split(" ");
                            var actualChange = false;
                            angular.forEach(differences, function (item) {
                                if (item != "fr-draggable") {
                                    actualChange = true;
                                }
                            })

                            if (actualChange) {
                                //ensure there is a listener
                                if (scope.changed) {
                                    //call the listener
                                    scope.changed();
                                }
                            }
                            
                        }
                    });
                });

                //after inserting an image
                $(element).on('froalaEditor.image.uploaded', function (e, editor, $img, response) {
                    // Image was inserted in the editor.
                    $timeout(function () {
                        scope.$apply(function () {
                            //set the model to the content of the editor
                            scope.ngModel = editor.html.get();
                            //ensure there is a listener
                            if (scope.changed) {
                                //call the listener
                                scope.changed();
                            }
                        });
                    }, 300);

                })

                function getDifference(a, b) {
                    var i = 0;
                    var j = 0;
                    var result = "";

                    while (j < b.length) {
                        if (a[i] != b[j] || i == a.length)
                            result += b[j];
                        else
                            i++;
                        j++;
                    }
                    return result;
                }


                var originalValue = "";
                //watch this for 2 way binding
                scope.$watch('ngModel', function (value) {
                    //don't update the editor if the update is coming from itself
                    if (!localUpdate) {
                        if (!value) {
                            value = "";
                        }

                        $(element).froalaEditor('html.set', value);

                        //will set the editor to on or of depending on disabled flag
                        var status = dataCardService.memoInfo.enabled ? "on" : "off";
                        $(element).froalaEditor('edit.' + status);
                        $timeout(function () {
                            originalValue = $(element).froalaEditor('html.get');
                        });
                    }

                    //set the flag to false
                    localUpdate = false;
                });
            })

        }


    }

})();